import { render, staticRenderFns } from "./Recurrences.vue?vue&type=template&id=38b0e290&scoped=true&"
import script from "./Recurrences.vue?vue&type=script&lang=js&"
export * from "./Recurrences.vue?vue&type=script&lang=js&"
import style0 from "./Recurrences.vue?vue&type=style&index=0&id=38b0e290&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b0e290",
  null
  
)

export default component.exports